<template>
  <div class="flow">
    <div @click="$router.go(-1)" class="c-pointer c_size_14 c_gray_drak">
      <i class="el-icon-arrow-left"></i>
      <span>返回</span>
    </div>
    <div class="flow-top" :style="`height:${80 + topHeight}px`">
      <div class="c-steps">
        <div
          v-for="(node, i) in nodes"
          :key="i"
          class="c-step"
          :class="
            (currentNode._id && currentNode._id == node._id) ||
            currentNode.nodeDef.nodeId == node.nodeDef.nodeId
              ? 'c-step-active'
              : ''
          "
        >
          <div
            class="c-step-node"
            :class="
              node._id && node.state == 10
                ? 'c-step-done'
                : node._id && node.state == 0
                ? 'c-step-doing'
                : 'c-step-todo'
            "
            @click="nodeClick(node)"
          >
            <i
              class="el-icon-circle-check c-step-icon-left"
              v-if="node._id && node.state == 10"
            ></i>
            <i class="el-icon-loading c-step-icon-left" v-if="node._id && node.state == 0"></i>
            {{ node.nodeDef.name }}
          </div>
          <i class="el-icon-right c-step-icon-right" v-if="i != nodes.length - 1"></i>
          <template v-if="node.subflows">
            <div
              v-for="(subflowNodes, j) in node.subflows"
              :key="j"
              class="c-steps-sub"
              :style="'top:' + 60 * (j + 1) + 'px'"
            >
              <i class="el-icon-bottom c-steps-bottom"></i>
              <div class="c-flex">
                <div
                  v-for="(node, i) in subflowNodes"
                  :key="i"
                  class="c-step"
                  :class="
                    (currentNode._id && currentNode._id == node._id) ||
                    currentNode.nodeDef.nodeId == node.nodeDef.nodeId
                      ? 'c-step-active'
                      : ''
                  "
                >
                  <div
                    class="c-step-node"
                    :class="
                      node._id && node.state == 10
                        ? 'c-step-done'
                        : node._id && node.state == 0
                        ? 'c-step-doing'
                        : 'c-step-todo'
                    "
                    @click="nodeClick(node)"
                  >
                    <i
                      class="el-icon-circle-check c-step-icon-left"
                      v-if="node._id && node.state == 10"
                    ></i>
                    <i
                      class="el-icon-loading c-step-icon-left"
                      v-if="node._id && node.state == 0"
                    ></i>
                    {{ node.nodeDef.name }}
                  </div>
                  <i
                    class="el-icon-right c-step-icon-right"
                    v-if="i != subflowNodes.length - 1"
                  ></i>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="flow-content" v-if="currentNode.nodeDef.nodeId">
      <div class="c-node-form">
        <div class="c-node-form-header">
          <div
            class="c-m-b-10 c-font-bold"
            v-if="formHeader.orderNum || formHeader.productModel || formHeader.deviceNumber"
          >
            <span v-if="formHeader.orderNum">工单编号：{{ formHeader.orderNum }}</span>
            <span v-if="formHeader.productModel">设备型号：{{ formHeader.productModel }}</span>
            <span v-if="formHeader.deviceNumber">设备SN号：{{ formHeader.deviceNumber }}</span>
          </div>
          <div>
            <span>节点名称：{{ currentNode.nodeDef.name }}</span>
            <span v-if="currentNode.createTime">创建时间：{{ currentNode.createTime }}</span>
            <span v-else>未创建</span>
          </div>
          <div>
            <div>
              {{ currentNode.state == 10 ? '处理人员' : '待处理人' }}：{{
                formatHandlerUserName(currentNode)
              }}
            </div>
            <div>
              <span v-if="currentNode.state == 10">处理时间：{{ currentNode.updateTime }}</span>
              <span v-else>待处理</span>
            </div>
          </div>
          <div class="c-node-form-timers">
            <el-button
              :type="!item.overtime ? 'plain' : i == 0 ? 'warning' : i == 1 ? 'danger' : 'info'"
              icon="el-icon-timer"
              round
              size="mini"
              v-for="(item, i) in countdownTimers"
              :key="i"
            >
              {{ item.msg }}
            </el-button>

            <el-popover
              v-if="
                countdownTimers.length > 0 &&
                  countdownTimers[0].overtime &&
                  (osg.has(`${colName},modifyTimer`) || osg.has(`ServiceAppointment,modifyTimer`))
              "
              placement="right"
              width="160"
              trigger="manual"
              v-model="delayTime.show"
            >
              <div>请选择要推迟多久？</div>
              <div style="margin:15px 0">
                <el-input
                  type="number"
                  placeholder="请输入"
                  v-model="delayTime.number"
                  class="time-type"
                >
                  <el-select
                    v-model="delayTime.timeType"
                    style="width:85px;"
                    slot="append"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.timeType"
                      :key="item.value"
                      :label="item.label"
                      :value="Number(item.value)"
                    ></el-option>
                  </el-select>
                </el-input>
              </div>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="delayTimeCancel(item)">取消</el-button>
                <el-button type="primary" size="mini" @click="delayTimeConfirm(item)">
                  确定
                </el-button>
              </div>
              <el-button
                slot="reference"
                @click="delayTime.show = !delayTime.show"
                icon="el-icon-edit"
                circle
                size="mini"
              ></el-button>
            </el-popover>
          </div>
        </div>
        <div class="c-node-form-content">
          <c-form
            v-if="currentNode.nodeDef.formDefId && formShow"
            :formData="formData"
            :fields="extFields"
            :options="options"
            :requestOptions="requestOptions"
            :currentNode="currentNode"
            ref="form"
            :upload="upload"
            labelWidth="150px"
            :area="area"
            :fullscreen="fullscreen"
            @screenChange="fullscreen = !fullscreen"
            @changeForm="osg.changeForm"
          >
            <template
              slot="phone"
              v-if="
                serviceState &&
                  (serviceAppointment.tenantId == '1340835581184723420' ||
                    workOrder.tenantId == '1340835581184723420')
              "
            >
              <el-input v-model="formData.phone">
                <el-button
                  slot="append"
                  icon="el-icon-phone"
                  class="c-blue"
                  @click="
                    osg.sobot.selfCallOut(
                      {
                        callNum: formData.phone,
                        bizType: 'review',
                        bizId: formData._id
                      },
                      callOutBack
                    )
                  "
                ></el-button>
              </el-input>
            </template>
            <template
              slot="leakagePart"
              v-if="workOrder && workOrder.exts && workOrder.exts.claimPartScopeList"
            >
              <el-select multiple v-model="formData.leakagePart" clearable placeholder="请选择">
                <template v-if="options.claimPart">
                  <el-option
                    v-for="item in options.claimPart.filter(item =>
                      workOrder.exts.claimPartScopeList.includes(item.value)
                    )"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </template>
              </el-select>
            </template>
          </c-form>
          <div v-else-if="currentNode.nodeDef.nodeType == 'placeOrder' && formShow">
            <el-card v-for="(order, i) in orders" :key="i" style="margin-bottom:20px;">
              <div class="c-font-bold">
                {{ order.type == '1' ? '订单' : '报价单' }}编号：{{ order.orderNumber }}
              </div>
              <div>客户姓名：{{ order.ownerName }}</div>
              <div>客户手机：{{ order.ownerPhone || '' }}</div>
              <div>产品总额：¥ {{ order.originPrice || 0 }}</div>
              <div
                v-if="
                  amountToFixed(
                    order.originPrice - amountToFixed(order.originPrice * order.discount)
                  )
                "
              >
                折扣金额：- ¥
                {{
                  amountToFixed(
                    order.originPrice - amountToFixed(order.originPrice * order.discount)
                  ) || 0
                }}
              </div>
              <div v-if="order.preferentialAmount">
                优惠金额：- ¥ {{ order.preferentialAmount }}
              </div>
              <div v-if="order.exts.couponsVal">活动优惠金额：- ¥ {{ order.exts.couponsVal }}</div>
              <div>应付金额：¥ {{ order.totalPrice }}</div>
              <div
                v-if="
                  serviceAppointment.tenantId == '2530349872480957853' ||
                    workOrder.tenantId == '2530349872480957853'
                "
              >
                <span v-if="order.exts && (order.exts.receipts || order.exts.receipts == 0)">
                  实收金额：¥ {{ order.exts.receipts || 0 }}
                </span>
              </div>
              <div v-else>实付金额：¥ {{ order.paidAmount || 0 }}</div>
              <div v-if="order.exts && order.exts.payType">
                支付类型： {{ formatPayType(order.exts.payType) }}
              </div>
              <div v-if="order.exts && order.exts.orderPurpose">
                订单用途： {{ order.exts.orderPurpose }}
              </div>
              <div>下单时间：{{ order.createTime }}</div>
              <el-table
                :data="order.productsDetail"
                border
                stripe
                v-if="order.productShow"
                style="border:1px solid #EBEEF5 !important;border-right:0 !important;border-bottom:0 !important;margin-top:20px;"
              >
                <el-table-column prop="product.name" label="名称"></el-table-column>
                <el-table-column prop="product.price" label="单价（元）"></el-table-column>
                <el-table-column prop="number" label="数量"></el-table-column>
                <el-table-column
                  prop="product.unit"
                  label="单位"
                  :formatter="formatUnit"
                ></el-table-column>
                <el-table-column label="合计（元）">
                  <template slot-scope="scope">
                    {{ Number(scope.row.product.price) * Number(scope.row.number) }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="c-center c-font-bold c-blue c-pointer c-m-t-15">
                <span v-if="!order.productShow" @click="order.productShow = true">
                  查看明细
                  <i class="el-icon-caret-bottom"></i>
                </span>
                <span v-else @click="order.productShow = false">
                  收起明细
                  <i class="el-icon-caret-top"></i>
                </span>
              </div>
            </el-card>
          </div>
          <div v-else class="c-center">
            <img src="../assets/empty.png" />
            <p class="c_info">无关联表单</p>
          </div>
        </div>
        <div
          class="c-node-form-footer"
          v-if="
            currentNode.nodeDef.handleButtons.filter(btn => {
              return (
                btn.show &&
                (((btn.action == 'allot' || btn.action == 'dispatch' || btn.action == 'accept') &&
                  currentNode.state == 0) ||
                  (btn.action == 'agree' ||
                  btn.action == 'disagree' ||
                  btn.action == 'rollback' ||
                  btn.action == 'crossNodeRollback' ||
                  btn.action == 'saveForm' ||
                  btn.action == 'close'
                    ? currentNode.state == 0
                    : btn.action == 'takeback'
                    ? currentNode.state == 10 && takebackShow(btn)
                    : btn.action == 'crossNodeTakeback'
                    ? currentNode.state == 10
                    : false)) &&
                auditable()
              );
            }).length > 0
          "
        >
          <template v-for="(btn, i) in currentNode.nodeDef.handleButtons">
            <el-button
              v-if="
                btn.show &&
                  (btn.action == 'allot' || btn.action == 'dispatch' || btn.action == 'accept') &&
                  currentNode.state == 0 &&
                  auditable()
              "
              :key="i"
              :type="btn.type"
              :icon="btn.icon"
              @click="audit(currentNode, btn)"
            >
              {{ btn.text || btn.name }}
            </el-button>
            <el-popover
              width="400"
              trigger="manual"
              :key="i"
              v-model="btn.visible"
              v-else-if="
                btn.show &&
                  (btn.action == 'agree' ||
                  btn.action == 'disagree' ||
                  btn.action == 'rollback' ||
                  btn.action == 'crossNodeRollback' ||
                  btn.action == 'saveForm' ||
                  btn.action == 'close'
                    ? currentNode.state == 0
                    : btn.action == 'takeback'
                    ? currentNode.state == 10 && takebackShow(btn)
                    : btn.action == 'crossNodeTakeback'
                    ? currentNode.state == 10
                    : false) &&
                  auditable()
              "
            >
              <div>
                <h4>{{ btn.text || btn.name }}</h4>
                <div v-if="btn.action == 'crossNodeRollback'" class="c-m-t-10">
                  <span class="c-m-r-10">请选择要退回到的节点</span>
                  <el-select
                    v-model="btn.rollbackWorkflowNodeId"
                    placeholder="请选择要退回到的节点"
                  >
                    <template v-for="node in nodes">
                      <el-option
                        v-if="node.state === 10"
                        :key="node.value"
                        :label="node.nodeDef.name"
                        :value="node._id"
                        @click.native="btn.nodeName = node.nodeDef.name"
                      ></el-option>
                    </template>
                  </el-select>
                </div>
                <el-input
                  type="textarea"
                  :rows="3"
                  :placeholder="btn.placeholder"
                  v-model="btn.remarks"
                  class="c-m-t-10 c-m-b-10"
                  @input="$forceUpdate()"
                ></el-input>
                <div class="c-fr">
                  <el-button
                    size="mini"
                    @click="
                      btn.visible = false;
                      btn.remarks = '';
                      $forceUpdate();
                    "
                  >
                    取消
                  </el-button>
                  <el-button size="mini" type="primary" @click="audit(currentNode, btn)">
                    确认
                  </el-button>
                </div>
              </div>
              <el-button
                :type="btn.type"
                :icon="btn.icon"
                slot="reference"
                @click="auditClick(currentNode, btn)"
              >
                {{ btn.text || btn.name }}
              </el-button>
            </el-popover>
          </template>
        </div>
      </div>
      <div class="c-flex c_flex_1 c-relative" v-if="tabsShow">
        <el-tabs
          type="card"
          class="flow-content-right c_flex_1"
          v-model="activeTab"
          @tab-click="tabClick"
        >
          <el-tab-pane name="correlation" v-if="osg.has(`Flow/${colName},correlation`)">
            <span slot="label">
              <i class="el-icon-document-copy"></i>
              关联工单
            </span>
            <div class="box-center-content">
              <el-table ref="correlation" :data="correlation">
                <c-table :fields="SAFields"></c-table>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane name="note" v-if="osg.has(`Flow/${colName},note`)">
            <span slot="label">
              <i class="el-icon-edit"></i>
              处理记录
            </span>
            <div class="c-note">
              <div class="box-center-tool">
                <div
                  v-if="
                    serviceAppointment.tenantId == '1340835581184723420' ||
                      workOrder.tenantId == '1340835581184723420'
                  "
                >
                  <i class="el-icon-info" style="margin-right: 6px;"></i>
                  <span style="color:red;">
                    请在时效内操作处理完毕，如未完结，请于时效内按进度更新处理记录
                  </span>
                </div>
                <div v-else></div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    note.vqeditor.content = '';
                    note.show = true;
                  "
                >
                  创建处理记录
                </el-button>
              </div>
              <div class="box-center-content">
                <el-timeline>
                  <el-timeline-item
                    v-for="(note, i) in note.data"
                    :key="i"
                    :timestamp="note.createTime + ' ' + note.createUserName"
                    placement="top"
                  >
                    <el-card>
                      <div
                        class="activity-card-content-node"
                        style="padding:10px;margin:0;"
                        v-html="note.content"
                        v-if="!note.show"
                      ></div>
                      <c-editor v-else :formData="note" :value="'content'" ref="editor"></c-editor>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <!-- markdown编辑器 -->
              <el-dialog
                title="处理记录"
                :visible.sync="note.show"
                @close="note.vqeditor.content = ''"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <c-editor :formData="note.vqeditor" :value="'content'" ref="editor"></c-editor>
                <div slot="footer">
                  <el-button type="primary" @click="saveNote">确 认</el-button>
                  <el-button
                    @click="
                      note.show = false;
                      note.vqeditor.content = '';
                    "
                  >
                    取 消
                  </el-button>
                </div>
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane name="followingUpNote" v-if="osg.has(`Flow/${colName},returnVisit`)">
            <span slot="label">
              <i class="el-icon-s-custom"></i>
              回访
            </span>
            <div class="box-center-tool">
              <div></div>
              <el-button type="primary" size="mini" @click="newFollowingUpNote">
                创建回访记录
              </el-button>
            </div>
            <div class="box-center-content">
              <el-table ref="followingUpNote" :data="followingUpNote.data">
                <c-table :fields="followingUpNoteFields"></c-table>
              </el-table>
            </div>
            <el-dialog
              title="回访记录"
              :visible.sync="followingUpNoteShow"
              @close="record.callData = {}"
            >
              <div class="box-center-content">
                <c-form
                  :formData="followingUpNoteFormData"
                  :fields="followingUpNoteFields"
                  :options="options"
                  :requestOptions="requestOptions"
                  ref="followingUpNoteFormData"
                  :upload="upload"
                  labelWidth="150px"
                  :area="area"
                  @changeForm="osg.changeForm"
                ></c-form>
              </div>
              <div slot="footer">
                <el-button size="mini" @click="followingUpNoteShow = false">
                  取消
                </el-button>
                <el-button size="mini" type="primary" @click="saveFollowingUpNote()">
                  确认
                </el-button>
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane name="followingUpNote" v-if="osg.has(`Flow/${colName},followingUpNote`)">
            <span slot="label">
              <i class="el-icon-document"></i>
              跟进记录
            </span>
            <el-timeline>
              <el-timeline-item
                v-for="(reco, i) in followingUpNote.data"
                :key="i"
                placement="top"
                :timestamp="reco.createTime + ' ' + reco.createUserName"
              >
                <el-card>
                  <div class="c-flex" v-if="reco.serviceAppointmentOrderNum">
                    <el-link
                      :href="'/ServiceAppointment/' + reco.serviceAppointmentId"
                      target="_blank"
                    >
                      <span class="c-blue">工单编号：</span>
                      <span class="c-blue">{{ reco.serviceAppointmentOrderNum }}</span>
                    </el-link>
                  </div>
                  <div class="c-flex">
                    <span>通话状态：</span>
                    <span>
                      {{
                        osg.formatCascade(
                          'LEADSTATUS',
                          osg.isJson(reco.dedicateMode)
                            ? JSON.parse(reco.dedicateMode)
                            : reco.dedicateMode
                        ) || ''
                      }}
                    </span>
                  </div>
                  <div v-if="reco.nextTime">
                    <span>下次联系时间：</span>
                    <span>{{ reco.nextTime }}</span>
                  </div>
                  <div v-if="reco.name">
                    <span>姓名：</span>
                    <span>{{ reco.name }}</span>
                  </div>
                  <div v-if="reco.phone">
                    <span>手机号：</span>
                    <span>{{ reco.phone }}</span>
                  </div>
                  <div v-if="reco.province">
                    <span>省市区：</span>
                    <span>{{ osg.formatProvince(null, null, reco.province) || '' }}</span>
                    <span v-if="reco.city">/{{ osg.formatCity(null, null, reco.city) || '' }}</span>
                    <span v-if="reco.district">
                      /{{ osg.formatDistrict(null, null, reco.district) || '' }}
                    </span>
                  </div>
                  <div v-if="reco.address">
                    <span>地址：</span>
                    <span>{{ reco.address }}</span>
                  </div>
                  <div v-if="reco.channel">
                    <span>信息渠道：</span>
                    <span
                      v-text="
                        osg.formatCascade(
                          'channel',
                          osg.isJson(reco.channel) ? JSON.parse(reco.channel) : reco.channel
                        )
                      "
                    ></span>
                  </div>
                  <div v-if="reco.leakagesite">
                    <span>维修部位：</span>
                    <span
                      v-text="
                        osg.formatCascadeMultiple(
                          'repairParts',
                          osg.isJson(reco.leakagesite)
                            ? JSON.parse(reco.leakagesite)
                            : reco.leakagesite
                        )
                      "
                    ></span>
                  </div>

                  <div v-if="reco.memo">备注： {{ reco.memo }}</div>
                  <el-button
                    v-if="reco.callId"
                    class="c-m-t-10"
                    icon="el-icon-view"
                    size="mini"
                    @click="viewCallRecord(reco.callId)"
                  >
                    查看通话记录
                  </el-button>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-tab-pane>
          <el-tab-pane name="callRecords" v-if="osg.has(`Flow/${colName},callRecords`)">
            <span slot="label">
              <i class="el-icon-phone"></i>
              通话记录
            </span>
            <div class="box-center-content">
              <el-timeline>
                <el-timeline-item
                  placement="top"
                  :timestamp="
                    '生成记录时间：' + item.createTime + ' 操作人：' + item.createUserName
                  "
                  v-for="(item, i) in callRecords.data"
                  :key="i"
                >
                  <el-card>
                    <div class="activity-card-header">
                      <span class="c-font-500">
                        <i class="el-icon-phone-outline c-w-30"></i>
                        <span v-if="item.callDirection == '0'">呼入</span>
                        <span v-else-if="item.callDirection == '1'">呼出</span>
                      </span>
                      <span v-if="item.callWay == 4">
                        {{ formatMiddleCallResult(item.middleCallResult) }}
                      </span>
                      <span v-else>{{ formatCallResult(item.callResult) }}</span>
                    </div>
                    <div class="activity-card-content">
                      <div>主叫：{{ item.callerName }} {{ item.caller }}</div>
                      <div>
                        被叫：{{
                          item.callWay == 4
                            ? item.calleeName || ''
                            : item.callDirection == '0'
                            ? item.calleeName || ''
                            : item.calleeName || formData.name || ''
                        }}{{ ' ' + item.callee }}
                      </div>
                      <div>通话时间：{{ item.startTimeStr }} 至 {{ item.endTimeStr }}</div>
                      <audio
                        v-if="item.recordUrl"
                        :controlsList="osg.has('Lead,downloadAudio') ? null : 'nodownload'"
                        @contextmenu.prevent="osg.has('Lead,downloadAudio') ? true : ''"
                        class="c-m-t-15"
                        controls
                        :src="item.recordUrl"
                      >
                        您的浏览器不支持 audio 标签。
                      </audio>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
            <el-dialog
              title="通话记录"
              id="callRecordDialog"
              :visible.sync="record.openCallRecord"
              @close="record.callData = {}"
            >
              <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
                <!-- v-for="(item, i) in record.callData" :key="i" -->
                <div class="activity-card">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span v-if="record.callData.callDirection == '0'">呼入</span>
                      <span v-else-if="record.callData.callDirection == '1'">呼出</span>
                    </span>
                    <span v-if="record.callData.callWay == 4">
                      {{ formatMiddleCallResult(record.callData.middleCallResult) }}
                    </span>
                    <span v-else>{{ formatCallResult(record.callData.callResult) }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      主叫：{{ record.callData.callerName }}
                      {{ record.callData.caller }}
                    </div>
                    <div>
                      被叫：{{
                        record.callData.callWay == 4
                          ? record.callData.calleeName || ''
                          : record.callData.callDirection == '0'
                          ? record.callData.calleeName || ''
                          : record.callData.calleeName || formData.name || ''
                      }}{{ ' ' + record.callData.callee }}
                    </div>
                    <div>
                      通话时间：{{ record.callData.startTimeStr }} 至
                      {{ record.callData.endTimeStr }}
                    </div>
                    <audio
                      v-if="record.callData.recordUrl"
                      class="c-m-t-15 w-1"
                      controls
                      :src="record.callData.recordUrl"
                      :controlsList="osg.has('Contract,downloadAudio') ? null : 'nodownload'"
                      @contextmenu.prevent="osg.has('Contract,downloadAudio') ? true : ''"
                    >
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <!-- <span>操作人：{{ item.createUserName }}</span> -->
                    <span></span>
                    <span>生成记录时间：{{ record.callData.createTime }}</span>
                  </div>
                </div>
              </div>
              <div slot="footer">
                <el-button
                  @click="
                    record.openCallRecord = false;
                    record.callData = {};
                  "
                >
                  关闭
                </el-button>
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane name="log" v-if="osg.has(`Flow/${colName},log`)">
            <span slot="label">
              <i class="el-icon-tickets"></i>
              业务动态
            </span>
            <el-timeline>
              <el-timeline-item
                v-for="(log, i) in log.fpi.data"
                :key="i"
                placement="top"
                :timestamp="log.createTime + ' ' + log.createUserName"
              >
                <el-card>
                  <h4>{{ log.title }}</h4>
                  <div v-if="log.extData && log.extData.length > 0" class="c_m_t_5">
                    <div class v-for="(sub, ui) in log.extData" :key="ui">
                      <div>{{ sub.name }} : {{ sub.value }}</div>
                    </div>
                  </div>
                  <div v-else-if="log.content" class="c_m_t_5">
                    {{ log.content || '' }}
                  </div>
                  <p>
                    <el-button
                      title="查看错误日志"
                      icon="el-icon-s-release"
                      circle
                      v-if="
                        osg.has(`${colName},exception`) &&
                          (log.exception || log.exceptionMsg || log.formData)
                      "
                      @click="
                        exception.exceptionMsg = log.exceptionMsg
                          ? log.exceptionMsg.replace(/(\r\n|\n|\r)/gm, '<br />')
                          : '';
                        exception.exception = log.exception
                          ? log.exception.replace(/(\r\n|\n|\r)/gm, '<br />')
                          : '';
                        exception.show = true;
                      "
                    ></el-button>
                  </p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
            <el-dialog
              title="异常日志"
              :visible.sync="exception.show"
              class="exception"
              @close="exception.show = false"
            >
              <div>
                <el-tabs v-model="exception.active">
                  <el-tab-pane label="exceptionMsg" name="exceptionMsg">
                    <div v-html="exception.exceptionMsg"></div>
                  </el-tab-pane>
                  <el-tab-pane label="exception" name="exception">
                    <div v-html="exception.exception"></div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane name="history" v-if="osg.has(`Flow/${colName},history`)">
            <span slot="label">
              <i class="el-icon-edit-outline"></i>
              属性变更记录
            </span>
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </el-tab-pane>
          <el-tab-pane
            name="serviceAppointment"
            v-if="osg.has(`Flow/${colName},serviceAppointment`)"
          >
            <span slot="label">
              <i class="el-icon-s-claim"></i>
              关联服务工单
            </span>
            <p>
              <!-- TODO:得力京城 工单详情页是flow.vue -->
              <el-button
                type="text"
                icon="el-icon-link"
                class="c_size_14"
                v-if="serviceAppointment.tenantId == '2530349872480957853'"
                @click="
                  osg.open(null, {}, '_blank', '/Flow/serviceAppointment/' + serviceAppointment._id)
                "
              >
                点击此处跳转到服务工单详情页
              </el-button>
              <el-button
                type="text"
                icon="el-icon-link"
                class="c_size_14"
                v-else
                @click="
                  osg.open(
                    null,
                    { id: serviceAppointment._id },
                    '_blank',
                    '/ServiceAppointment/' + serviceAppointment._id
                  )
                "
              >
                点击此处跳转到服务工单详情页
              </el-button>
            </p>
            <c-form
              style="margin-top:5px;"
              :formData="serviceAppointment"
              :fields="SAFields"
              :options="options"
              ref="serviceAppointmentForm"
              :upload="upload"
              labelWidth="150px"
              :area="area"
              disabled
              @changeForm="osg.changeForm"
            ></c-form>
          </el-tab-pane>
          <el-tab-pane
            name="accidentWarrantyPdfList"
            v-if="osg.has(`Flow/${colName},accidentWarrantyPdfList`)"
          >
            <span slot="label">
              <i class="el-icon-s-claim"></i>
              出险质保PDF列表
            </span>
            <el-table ref="table" :data="accidentWarrantyPdfList" empty-text="PDF列表为空">
              <el-table-column prop="index" label="序号" width="100"></el-table-column>
              <el-table-column label="PDF地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-link
                    :href="
                      'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                        encodeURIComponent(upload.downloadUrl + scope.row.url)
                    "
                    target="_blank"
                  >
                    {{ upload.downloadUrl + scope.row.url }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="concern" style="position:absolute" v-if="osg.has(`Flow/${colName},concern`)">
          <el-tooltip
            effect="dark"
            content="关注工单后，工单流转过程中的动态，会以站内信的方式通知到您。"
            placement="top"
          >
            <el-button
              type="success"
              icon="el-icon-star-off"
              round
              size="small"
              v-if="
                colName == 'serviceAppointment'
                  ? serviceAppointment &&
                    serviceAppointment.concernUserIds &&
                    serviceAppointment.concernUserIds.indexOf(user._id) != -1
                  : colName == 'workOrder'
                  ? workOrder &&
                    workOrder.concernUserIds &&
                    workOrder.concernUserIds.indexOf(user._id) != -1
                  : false
              "
              @click="concern"
            >
              已关注
            </el-button>
            <el-button
              v-else
              type="plain"
              icon="el-icon-star-off"
              round
              size="small"
              @click="concern"
            >
              未关注
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <!-- 收起/展开 右侧标签页区域 -->
      <el-button
        v-if="tabsShow"
        @click="tabsShow = 0"
        icon="el-icon-d-arrow-right"
        plain
        circle
        class="tabShowBtn"
        title="收起"
      ></el-button>
      <el-button
        v-else-if="tabsShow === 0"
        @click="tabsShow = true"
        icon="el-icon-d-arrow-left"
        plain
        circle
        class="tabShowBtn"
        title="展开"
      ></el-button>
    </div>

    <el-dialog
      title="服务资源"
      :visible.sync="SR.show"
      custom-class="sr-dialog"
      @close="cancelSR"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="c-flex c-flex-end">
        <el-select
          v-if="SR.nodeType == 'allot'"
          v-model="SR.ids"
          placeholder="搜索服务区域"
          class="screen"
          clearable
          filterable
          remote
          :remote-method="getServiceTerritory"
          @clear="
            SR.fpi.page = 1;
            getServiceTerritory();
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            SR.selectId = '';
            SR.selectRow = {};
            getSR();
          "
        >
          <el-option
            v-for="(item, i) in options.serviceTerritory"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-if="SR.nodeType == 'dispatch'"
          v-model="SR.resourceRoleIds"
          multiple
          placeholder="筛选资源角色"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <template v-for="item in SR.resourceRoles">
            <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
          </template>
        </el-select>
        <el-input
          placeholder="请输入资源名称"
          v-model="SR.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @keyup.enter.native="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              SR.fpi.page = 1;
              getSR();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="SR.loading"
        :data="SR.fpi.data"
        row-key="_id"
        ref="srTable"
        height="100%"
        style="width: 100%; min-height: 440px"
        fit
        header-row-class-name="c-black-dark"
        highlight-current-row
        @row-click="handleSRRowClick"
        @selection-change="handleSRRowSelectionChange"
      >

        <el-table-column label="选择" type="selection" width="50px;">
<!--          <template slot-scope="scope">-->
<!--            <el-radio v-model="SR.selectId" :label="scope.row._id">&nbsp;</el-radio>-->
<!--          </template>-->
        </el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column
          prop="resourceType"
          label="资源类型"
          :formatter="formatSRType"
        ></el-table-column>
        <el-table-column label="资源">
          <template slot-scope="scope">
            <template
              v-if="scope.row.resourceType == 'partner' || scope.row.resourceType == 'serviceCrew'"
            >
              {{ formatOrg(scope.row.serviceCrewId) }}
            </template>
            <template v-else>
              {{ formatUser(scope.row.relatedRecordId) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="resourceRoles"
          label="资源角色"
          v-if="SR.nodeType == 'dispatch'"
          :formatter="formatResourceRoles"
        ></el-table-column>
        <el-table-column
          prop="_id"
          label="服务区域"
          :formatter="formatST"
          v-if="SR.nodeType == 'allot'"
        ></el-table-column>
        <el-table-column
          prop="workType"
          label="工作状态"
          :formatter="formatWorkingState"
          v-if="SR.nodeType == 'dispatch'"
        ></el-table-column>
        <el-table-column
          prop="exts.allCount"
          label="待完成工单个数"
          v-if="SR.allCountShow"
        ></el-table-column>
        <el-table-column
          prop="exts.otherCount"
          label="待完成工单类型"
          v-if="SR.otherCountShow"
        ></el-table-column>
        <el-table-column
          prop="exts.numberOfThisMonth"
          label="本月累计工单数量"
          v-if="SR.numberOfThisMonth"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="c-flex c-flex-item c-flex-between">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="SR.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="SR.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="SR.fpi.total"
        ></el-pagination>
        <div>
          <el-button type="primary" @click="saveSR">确 定</el-button>
          <el-button @click="cancelSR">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Flow',
  data() {
    window.$this = this;
    return {
      workflowId: '', //主流程运行时工作流id
      colName: '',
      extId: '',
      id: null,
      nodes: [],
      currentNode: { nodeDef: {} },
      extFields: [],
      SAFields: [],
      followingUpNoteFields: [],
      fieldsObj: {},
      fieldsObjCopy: {},
      options: {
        //服务资源
        codecfg_resourceType: {
          codeId: 'resourceType'
        },
        codecfg_resourceRoles: {
          codeId: 'resourceRoles'
        },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' },
        returnList: [],
        codecfg_payType: { codeId: 'payType' },
        codecfg_workingStates: { codeId: 'workState' },
        codecfg_timeType: { codeId: 'planTimeType' }
      },
      orgIds: [],
      roleIds: [],
      userIds: [],
      formData: { exts: {} },
      area: {
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        },
        options: this.osg.areaList
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      topHeight: 0, //顶部流程高度
      loginAccount: {}, //当前登陆账号信息
      //  分派单服务资源
      SR: {
        show: false,
        fpi: {},
        selectRow: {},
        selectRowNames:'',
        selectId: '',
        selectIds: [],
        searchValue: '',
        ids: [], //选择服务区域筛选出的关联的服务资源id
        resourceType: [], //筛选服务资源类型
        resourceRoleIds: [], //筛选资源角色id
        resourceRoles: [], //筛选资源角色
        nodeType: '', //当前节点类型
        loading: false, //表格数据加载
        btn: {},
        allCountShow: false, //待完成工单个数是否展示
        otherCountShow: false //待完成工单类型
      },
      // 标签页
      activeTab: 'note',
      tabNames: [
        'correlation', // 关联工单
        'note', // 处理记录
        'returnVisit', // 回访
        'followingUpNote', // 跟进记录
        'callRecords', // 通话记录
        'log', // 业务动态
        'history', // 属性变更记录
        'serviceAppointment', // 关联服务工单
        'accidentWarrantyPdfList', // 出险质保PDF列表
        'concern' // 关怀
      ],
      tabsShow: false,
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historySmodule: '',
      historyFpi: {
        page: 1,
        rows: 0,
        data: []
      },
      // 异常日志
      exception: {
        exceptionMsg: '',
        exception: '',
        show: false,
        active: 'exceptionMsg'
      },
      // 跟进记录
      note: {
        data: [],
        show: false,
        vqeditor: this.$util.vqeditor
      },
      // 服务工单数据
      serviceAppointment: { exts: {} },
      // 工单关联订单
      orders: [],
      // 售后工单数据
      workOrder: { exts: {} },
      // 跟进记录
      followingUpNote: { data: [] },
      followingUpNoteShow: false,
      followingUpNoteFormData: { exts: {} },
      // 关联表单
      correlation: [],
      // 通话记录
      callRecords: { data: [] },
      record: { callData: [], openCallRecord: false },
      // 当前登录人
      user: {},
      // 超时提醒
      countdownTimer: null, //定时器
      countdownTimers: [], //多个超时提醒
      serviceState: null,
      accidentWarrantyPdfList: [], //出险质保PDF
      // TODO:贝壳如视表头展示:设备SN号、设备型号、工单编号
      formHeader: {
        orderNum: '',
        deviceNumber: '',
        productModel: ''
      },
      requestOptions: {
        // TODO:视图更新 flow-form-table
        selectedMachines: [] //报价清单子表机台编号
      },
      fullscreen: false,
      formShow: false,
      // 推迟时间
      delayTime: {
        show: false,
        number: 30,
        timeType: 1
      }
    };
  },
  mounted() {
    this.colName = this.osg.param('colName');

    if (!this.osg.has(`Flow/${this.colName},note`) && this.osg.has(`Flow/${this.colName},log`)) {
      this.activeTab = 'log';
    }
    this.id = this.osg.param('id');
    this.osg.setLastRowId('ServiceAppointments', this.id);

    this.user = JSON.parse(sessionStorage['loginAccount']);
    if (sessionStorage['userData']) {
      this.serviceState = JSON.parse(sessionStorage['userData']).serviceState || '';
    }

    this.getExtByColName(() => {
      this.getFunctions();
      this.getNodes();
    });
    this.osg.codeoption();
    this.isTabsShow();
    this.getNote();

    // 工单工作流查询工单数据，支持关注功能
    if (this.colName == 'serviceAppointment') {
      this.getServiceAppointmentById();
    } else if (this.colName == 'workOrder') {
      this.getWorkOrderById(() => {
        // 查询售后工单关联的服务工单
        if (this.workOrder.serviceAppointmentId) {
          this.osg.getFields(
            'serviceAppointment',
            () => {
              this.$forceUpdate();
              this.getServiceAppointmentById(this.workOrder.serviceAppointmentId);
            },
            null,
            'SAFields'
          );
        }

        // 获取跟进记录、通话记录
        if (this.workOrder.phone) {
          this.osg.getFields(
            'followingUpNote',
            () => {
              this.getFollowingUpNote();
              this.getCallRecords();
            },
            this,
            'followingUpNoteFields'
          );
        }

        //有出险质保菜单则查询
        if (this.osg.has(`Flow/${this.colName},accidentWarrantyPdfList`)) {
          this.getAccidentWarrantyPdfList(this.workOrder.exts.docId);
        }
      });
    }

    // 获取跟进记录、通话记录
    if (this.osg.has(`Flow/${this.colName},returnVisit`)) {
      this.osg.getFields(
        'followingUpNote',
        () => {
          this.getFollowingUpNote();
        },
        this,
        'followingUpNoteFields'
      );
    }
  },
  methods: {
    refresh() {
      this.formShow = false;
      this.$nextTick(() => {
        this.formShow = true;
      });
    },
    getExtByColName(callback) {
      this.osg.ajax('biz/ext/queryByColName/' + this.colName + '.do', {}, res => {
        this.extId = res.entity._id;
        if (callback) callback();
      });
    },
    // 获取函数库定义的行数 并动态创建函数
    getFunctions() {
      this.osg.ajax(
        'definedFunction/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:cfe|integer#and': 1,
          sortField: 'group,order',
          sortOrder: 'asc'
        },
        res => {
          let functions = res.data;

          functions.map(func => {
            switch (func.paramCount) {
              case 0:
                window[func.name] = new Function(func.feFunction);
                break;
              case 1:
                window[func.name] = new Function('a', func.feFunction);
                break;
              case 2:
                window[func.name] = new Function('a', 'b', func.feFunction);
                break;
              case 3:
                window[func.name] = new Function('a', 'b', 'c', func.feFunction);
                break;
              case 4:
                window[func.name] = new Function('a', 'b', 'c', 'd', func.feFunction);
                break;
              case 5:
                window[func.name] = new Function('a', 'b', 'c', 'd', 'e', func.feFunction);
                break;
              default:
                return;
            }
          });
        }
      );
    },
    getNodes() {
      this.osg.ajax(
        '/biz/extForm/findByIdWithWorkflow.do',
        { extId: this.extId, id: this.id },
        res => {
          if (!res.data.workflow) {
            // replace防止返回当前页面重复跳转
            if (this.colName == 'serviceAppointment') {
              this.$router.replace({ path: '/ServiceAppointment/' + this.id });
            } else if (this.colName == 'workOrder') {
              this.$router.replace({ path: '/WorkOrder/' + this.id });
            }
            return;
          }
          this.workflowId = res.data.workflow._id;
          let defNodes = res.data.workflow.def.nodes;
          let runNodes = res.data.workflowNode.slice(1);
          this.nodes = [];

          let userIds = this.userIds;
          let roleIds = this.roleIds;
          let orgIds = this.orgIds;
          for (let i = 0; i < defNodes.length; i++) {
            console.log(defNodes[i]);
            // 合并定义节点和运行时节点
            this.nodes.push(runNodes[i] || { nodeDef: defNodes[i] });
            let node = this.nodes[i];
            node.nodeDef.handleButtons = node.nodeDef.handleButtons || [];
            node.nodeDef.userChooseRule = node.nodeDef.userChooseRule || ''; //防止undefined报错关联
            // 收集处理人id和待处理组织/角色/人员,用作返显
            if (node.handleUserId) {
              userIds.push(node.handleUserId);
            } else if (node.nodeDef.userChooseRule.indexOf('org:') != -1) {
              orgIds = orgIds.concat(node.nodeDef.userChoose);
            } else if (node.nodeDef.userChooseRule.indexOf('role:') != -1) {
              roleIds = roleIds.concat(node.nodeDef.userChoose);
            } else if (node.nodeDef.userChooseRule.indexOf('user:') != -1) {
              userIds = userIds.concat(node.nodeDef.userChoose);
            } else if (!node.nodeDef.userChooseRule || node.nodeDef.userChooseRule == 'starter') {
              userIds = userIds.concat(node.handlerIds);
            }
          }
          if (userIds.length > 0) this.getUsers(userIds.join());
          if (roleIds.length > 0) this.getRoles(roleIds.join());
          if (orgIds.length > 0) this.getOrgs(orgIds.join());
          // 默认点击当前待办节点（没有待办即最后一个节点）
          this.nodeClick(this.nodes[runNodes.length - 1]);
          console.log('nodes', this.nodes);
        },
        { noload: true }
      );
    },
    // 获取跟进记录
    getFollowingUpNote() {
      var params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      if (this.colName == 'workOrder') {
        params['callPhone'] = this.workOrder.phone;
      } else {
        params['bizType'] = this.colName;
        params['bizId'] = this.id;
      }
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          this.followingUpNote = res;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    newFollowingUpNote() {
      this.followingUpNoteFormData = { exts: {} };
      this.followingUpNoteShow = true;
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    // 保存跟进记录
    saveFollowingUpNote(callback) {
      if (!this.osg.validate('followingUpNoteFormData')) return;
      //跟进记录需要前端生成_id
      this.followingUpNoteFormData._id = this.randomUUid();
      let params = {
        bizType: this.colName,
        bizId: this.id,
        serviceAppointmentOrderNum: this.serviceAppointment.orderNum || this.workOrder.code
      };
      params = Object.assign(params, this.followingUpNoteFormData);
      this.osg.ajax('followingUpNote/upsert.do', params, () => {
        this.getFollowingUpNote();
        this.followingUpNoteShow = false;
        if (callback) callback();
      });
    },
    // 获取通话记录
    getCallRecords() {
      if (!this.id || !this.colName) return;
      var params = {
        bizId: this.id,
        bizType: this.colName == 'workOrder' ? 'WorkOrder' : this.colName,
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/sobot/query.do',
        params,
        res => {
          this.callRecords = res;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'in:_id|array#and': orgIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.orgs = res.data;
          if (resolve) resolve();
        },
        {
          noload: true
        }
      );
    },
    getRoles(roleIds) {
      this.osg.ajax(
        'role/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:_id|array#and': roleIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
        },
        {
          noload: true
        }
      );
    },
    getUsers(userIds, resolve) {
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1',
          'in:_id|array#and': userIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          if (resolve) resolve();
        },
        {
          noload: true
        }
      );
    },
    // 返显处理人
    formatHandlerUserName(node) {
      // 处理人去重
      if (node.handleUserId) {
        if (node.handleUserId == '0' || node.handleUserId == 'script') {
          return '系统';
        } else {
          return this.osg.codelabel('users', node.handleUserId);
        }
      } else if (!node.nodeDef.userChooseRule || node.nodeDef.userChooseRule == 'starter') {
        return this.osg.codelabelForArray('users', Array.from(new Set(node.handlerIds)));
      } else if (node.nodeDef.userChooseRule.indexOf('org:') != -1) {
        return this.osg.codelabelForArray('orgs', Array.from(new Set(node.nodeDef.userChoose)));
      } else if (node.nodeDef.userChooseRule.indexOf('role:') != -1) {
        return this.osg.codelabelForArray('roles', Array.from(new Set(node.nodeDef.userChoose)));
      } else if (node.nodeDef.userChooseRule.indexOf('user:') != -1) {
        return this.osg.codelabelForArray('users', Array.from(new Set(node.nodeDef.userChoose)));
      }
    },
    nodeClick(node) {
      this.currentNode = node;
      console.log(node.nodeDef.name, node);
      // 展示超时提醒倒计时
      this.countdownTimers = [];
      this.countdownTimer && clearInterval(this.countdownTimer);
      node.createTime && this.countdown(node);

      let formDefId = node.nodeDef.formDefId;
      let formDataId = node.formDataId;
      if (formDefId) {
        this.formShow = false;
        this.osg.getFields(
          null,
          () => {
            if (this.extFields && this.extFields.length > 0) {
              this.historySmodule = this.extFields[0].colName;
              if (this.historySmodule) this.getHistory();
            }
            if (formDataId) {
              this.osg.ajax(
                'biz/extForm/query/' + formDefId + '.do',
                { _id: formDataId },
                res => {
                  let formData = res.data[0] || { exts: {} };
                  this.$util.renderExtField(this.extFields, formData);
                  this.$set(this, 'formData', formData);
                  this.formulaParse(node, 'initForm'); // 执行表单初始化公式
                  this.formShow = true;
                  this.$forceUpdate();

                  // 解决加载节点表单 需要赋值其他字段的情况
                  // let that = this;
                  // this.extFields.map(f => {
                  //   if (f.type == 'bizSelect' && f.frontEndConfig.initRequest) {
                  //     let value = f.preset ? that.formData[f.name] : that.formData.exts[f.name];
                  //     value = value || (f.multiple ? [] : '');
                  //     that.$refs.form && that.$refs.form.bizSelectChange(f, value);
                  //   }
                  // });
                },
                {
                  noload: true
                }
              );
            } else {
              let formData = { exts: {} };
              this.$util.renderExtField(this.extFields, formData);
              this.$set(this, 'formData', formData);
              this.formulaParse(node, 'initForm'); // 执行表单初始化公式
              this.$nextTick(() => {
                this.formShow = true;
                this.$forceUpdate();
                if (this.$refs.form && this.$refs.form.$refs.formData)
                  this.$refs.form.$refs.formData.resetFields();
              });
            }
          },
          null,
          null,
          node.nodeDef.formDefId
        );
      } else if (node.nodeDef.nodeType == 'placeOrder') {
        this.formShow = true;
        this.getOrders();
      } else {
        this.extFields = [];
        this.formData = { exts: {} };
        if (this.$refs.form && this.$refs.form.$refs.formData)
          this.$refs.form.$refs.formData.resetFields();
        this.formShow = true;
        this.$forceUpdate();
      }

      // 关联子流程
      if (node.nodeDef.nodeType == 'subflow' || node.nodeDef.nodeType == 'subflows') {
        this.getSubflows(node);
      } else if (node.workflowId == this.workflowId) {
        // 点击子流程节点时保持展开高度
        // this.topHeight = 0;
      }

      // 查询日志
      this.getLog();
    },
    // 当前登录人是否有权限处理当前待办节点
    auditable() {
      let handlerIds = this.currentNode.handlerIds;
      if (!handlerIds || handlerIds.length == 0) return;
      if (sessionStorage['loginAccount']) {
        var userId = JSON.parse(sessionStorage['loginAccount'])._id;
        var orgId = JSON.parse(sessionStorage['loginAccount']).orgId;
      }
      if (sessionStorage['currentRole']) {
        var roleId = JSON.parse(sessionStorage['currentRole'])._id;
      }
      if (
        handlerIds.indexOf(orgId + '+' + roleId) != -1 ||
        handlerIds.indexOf(userId) != -1 ||
        handlerIds.indexOf(orgId) != -1 ||
        handlerIds.indexOf(roleId) != -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 当前节点是否允许撤回
    takebackShow() {
      // 当前节点状态是10即已办，才会进入此方法
      for (let i = 0; i < this.nodes.length; i++) {
        // 查找当前节点在流程中的位置
        if (this.currentNode._id == this.nodes[i]._id) {
          // 获取下一个节点
          let nextNode = this.nodes[i + 1];
          if (!nextNode) {
            // 如果当前节点最后一个节点，不允许撤回。
            return false;
          } else if (nextNode.state == 0) {
            // 如果下一节点状态是待办，当前节点允许撤回
            return true;
          } else {
            // 如果下一节点状态也是已办，当前节点不允许撤回
            return false;
          }
        }
      }
    },
    // 点击审批按钮，关闭其他审批弹窗。
    auditClick(node, btn) {
      //表单校验，btn.action等于saveForm或close，保存表单、关闭表单不需要校验必填。
      if ((btn.action == 'agree' || btn.action == 'disagree') && !this.osg.validate()) {
        this.osg.toast('表单填写不正确', 'warning');
        return;
      }
      for (let button of node.nodeDef.handleButtons) {
        if (button.action == btn.action) {
          if (!btn.visible) {
            if (btn.comment) {
              btn.visible = !btn.visible;
            } else {
              // 无需评语
              this.audit(node, btn);
            }
          } else {
            btn.visible = !btn.visible;
          }
        } else {
          button.visible = false;
        }
      }
      this.$forceUpdate();
    },
    audit(node, btn) {
      if (btn.action == 'agree') {
        this.saveFormData(node, formDataId => {
          this.process(node, btn, formDataId);
        });
        return;
      } else if (btn.action == 'disagree') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.saveFormData(node, formDataId => {
            this.process(node, btn, formDataId);
          });
          return;
        }
      } else if (btn.action == 'saveForm') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.saveFormData(node, () => {
            this.osg.toast('保存成功！', 'success');
            btn.visible = false;
            btn.remarks = '';
            this.$forceUpdate();
          });
          return;
        }
      } else if (btn.action == 'takeback') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.takebackWorkflow(node, btn);
        }
      } else if (btn.action == 'rollback') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.rollbackWorkflow(node, btn);
        }
      } else if (btn.action == 'crossNodeRollback') {
        if (!btn.rollbackWorkflowNodeId) {
          this.osg.toast('请选择要退回到的节点！', 'warning');
          return;
        } else if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.crossNodeRollbackWorkflow(node, btn);
        }
      } else if (btn.action == 'takeback') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.takebackWorkflow(node, btn);
        }
      } else if (btn.action == 'crossNodeTakeback') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.crossNodeTakebackWorkflow(node, btn);
        }
      } else if (btn.action == 'close') {
        if (!btn.remarks && btn.comment) {
          this.osg.toast('请输入审批意见！', 'warning');
          return;
        } else {
          this.closeWorkflow(node, btn);
        }
      } else if (btn.action == 'accept') {
        this.osg.confirm('是否确认' + btn.text, () => {
          this.process(node, btn, null, {
            handlerId: JSON.parse(sessionStorage['loginAccount'])._id
          });
        });
        return;
      } else if (btn.action == 'allot' || btn.action == 'dispatch') {
        if (node.nodeDef.formDefId) {
          if (!this.osg.validate()) {
            this.osg.toast('表单填写不正确', 'warning');
            return;
          }
          this.saveFormData(node, () => {
            this.openSR(node, btn);
          });
        } else {
          this.openSR(node, btn);
        }
      }
    },
    saveFormData(node, callback) {
      this.formData.state = 1; // 默认状态1
      this.$util.saveFormatExtField(this.extFields, this.formData);
      this.formulaParse(node, 'submitForm'); // 执行表单提交校验公式
      this.osg.ajax(
        'biz/extForm/upsert/' + node.nodeDef.formDefId + '.do',
        { dataStr: JSON.stringify(this.formData) },
        res => {
          if (callback) callback(res.data._id);
        }
      );
    },
    //处理工作流
    process(node, btn, formDetaId, opt = {}) {
      let param = {
        workflowNodeId: node._id, //当前运行时节点id
        nodeFormDefId: node.nodeDef.formDefId, //节点表单定义id
        nodeFormDataId: formDetaId, //关联节点表单数据id
        smodule: this.colName,
        action: btn.action,
        remark: btn.remarks,
        sid: this.id, //来源数据id
        currentOrgId: opt.currentOrgId, // 分给的组织
        handlerId: opt.handlerId // 派给的人
      };
      if (opt.handlerIds){
        param.handlerIds = opt.handlerIds;
      }
      if (opt.currentOrgIds){
        param.currentOrgIds = opt.currentOrgIds;
      }
      this.osg.ajax(
        'workflow/process.do',
        param,
        () => {
          this.getNodes();
          btn.visible = false;
          btn.remarks = '';
          this.$forceUpdate();
        }
      );
    },
    /**
     * 工作流撤回
     */
    takebackWorkflow(node, btn) {
      this.osg.confirm('是否确认撤回？撤回将删除下一节点！', () => {
        let params = {
          workflowNodeId: node._id,
          smodule: this.colName,
          action: btn.action,
          remark: btn.remarks,
          sid: this.id
        };
        this.osg.ajax('workflow/takebackWorkflow.do', params, () => {
          this.getNodes();
          btn.visible = false;
          btn.remarks = '';
          this.$forceUpdate();
        });
      });
    },
    // 跨节点撤回
    crossNodeTakebackWorkflow(node, btn) {
      let lastNode = {};
      for (let n of this.nodes) {
        if (n.state === 0) {
          lastNode = n;
          break;
        }
      }
      this.osg.confirm(
        `是否确认从“${lastNode.nodeDef.name}节点”撤回到“${node.nodeDef.name}”节点？撤回将删除后续节点！`,
        () => {
          let params = {
            workflowNodeId: lastNode._id,
            rollbackWorkflowNodeId: node._id,
            smodule: this.colName,
            action: btn.action,
            context: btn.remarks,
            sid: this.id
          };
          this.osg.ajax('workflow/rollbacksWorkflow.do', params, () => {
            this.getNodes();
            btn.visible = false;
            btn.rollbackWorkflowNodeId = '';
            btn.remarks = '';
            this.$forceUpdate();
          });
        }
      );
    },
    /**
     * 工作流关闭
     */
    closeWorkflow(node, btn) {
      this.osg.confirm('是否确认关闭当前工作流？', () => {
        let params = {
          extId: this.extId,
          id: this.id,
          reason: btn.remarks
        };
        this.osg.ajax('biz/extForm/forceCloseServiceById.do', params, () => {
          this.getNodes();
          btn.visible = false;
          btn.remarks = '';
          this.$forceUpdate();
        });
      });
    },
    /**
     * 工作流退回
     */
    rollbackWorkflow(node, btn) {
      this.osg.confirm('是否确认退回？退回将删除当前节点！', () => {
        let params = {
          workflowNodeId: node._id,
          smodule: this.colName,
          action: btn.action,
          remark: btn.remarks,
          sid: this.id
        };
        this.osg.ajax('workflow/rollbackWorkflow.do', params, () => {
          this.getNodes();
          btn.visible = false;
          btn.remarks = '';
          this.$forceUpdate();
        });
      });
    },
    // 跨节点退回
    crossNodeRollbackWorkflow(node, btn) {
      this.osg.confirm(
        `是否确认从当前节点退回到“${btn.nodeName}”节点？退回将删除“${btn.nodeName}”节点后续的节点！`,
        () => {
          let params = {
            workflowNodeId: node._id,
            rollbackWorkflowNodeId: btn.rollbackWorkflowNodeId,
            smodule: this.colName,
            action: btn.action,
            context: btn.remarks,
            sid: this.id
          };
          this.osg.ajax('workflow/rollbacksWorkflow.do', params, () => {
            this.getNodes();
            btn.visible = false;
            btn.rollbackWorkflowNodeId = '';
            btn.nodeName = '';
            btn.remarks = '';
            this.$forceUpdate();
          });
        }
      );
    },
    getSubflows(node) {
      this.osg.ajax(
        `workflow/queryByParentWorkflowNodeId/${node._id}.do`,
        {
          'ne:state|integer#and': '-1'
        },
        res => {
          // 将1条或多条子流程的节点 放入父运行时节点
          node.subflows = [];

          let userIds = [];
          let roleIds = [];
          let orgIds = [];

          for (let flow of res.data) {
            let defNodes = flow.def.nodes;
            let runNodes = flow.workflowNodeList;
            let nodes = [];

            for (let i = 0; i < defNodes.length; i++) {
              // 合并定义节点和运行时节点
              nodes.push(runNodes[i] || { nodeDef: defNodes[i] });
              let node = nodes[i];
              node.nodeDef.handleButtons = node.nodeDef.handleButtons || [];
              // 收集处理人id和待处理组织/角色/人员 用作返显
              if (node.handleUserId) {
                if (this.userIds.indexOf(node.handleUserId) == -1) userIds.push(node.handleUserId);
              } else if (node.nodeDef.userChooseRule.indexOf('org:') != -1) {
                node.nodeDef.userChoose.map(id => {
                  if (this.orgIds.indexOf(id) == -1) {
                    orgIds.push(id);
                  }
                });
              } else if (node.nodeDef.userChooseRule.indexOf('role:') != -1) {
                node.nodeDef.userChoose.map(id => {
                  if (this.roleIds.indexOf(id) == -1) {
                    roleIds.push(id);
                  }
                });
              } else if (node.nodeDef.userChooseRule.indexOf('user:') != -1) {
                node.nodeDef.userChoose.map(id => {
                  if (this.userIds.indexOf(id) == -1) {
                    userIds.push(id);
                  }
                });
              } else if (!node.nodeDef.userChooseRule || node.nodeDef.userChooseRule == 'starter') {
                node.handlerIds.map(id => {
                  if (this.userIds.indexOf(id) == -1) {
                    userIds.push(id);
                  }
                });
              }
            }
            node.subflows.push(nodes);
          }

          if (node.workflowId == this.workflowId) {
            this.topHeight = 60 * node.subflows.length; // 主流程展开增加高度
          } else {
            this.topHeight += 60 * node.subflows.length; // 子流程继续展开子流程增加高度
          }

          console.log(node.nodeDef.name + '的子流程节点：', node.subflows);
          this.$forceUpdate();
          // 已查询过的id不再重复收集查询
          if (userIds.length > 0) this.getUsers(this.userIds.concat(userIds).join());
          if (roleIds.length > 0) this.getRoles(this.roleIds.concat(roleIds).join());
          if (orgIds.length > 0) this.getOrgs(this.orgIds.concat(orgIds).join());
        },
        {
          noload: true
        }
      );
    },
    //展示分配服务资源
    openSR(node, btn) {
      //赋值接单类型、资源类型、资源角色
      this.SR.nodeType = btn.action || node.nodeDef.nodeTypeOld || node.nodeDef.nodeType;
      this.SR.resourceType = node.nodeDef.resourceType;
      this.SR.resourceRoleIds = node.nodeDef.resourceRoles || [];
      if (this.SR.resourceRoleIds.length > 0) {
        this.SR.resourceRoles = this.options.resourceRoles.filter(item => {
          return this.SR.resourceRoleIds.indexOf(item.value) != -1;
        });
      } else {
        this.SR.resourceRoles = this.options.resourceRoles;
      }
      this.SR.btn = btn;

      this.$forceUpdate();
      if (this.SR.nodeType == 'allot') {
        this.getServiceTerritory();
      }
      this.SR.show = true;
      this.SR.loading = true;
      this.getSR();
    },
    //获取服务资源
    getSR() {
      let params = {
        page: this.SR.fpi.page || 1,
        rows: this.SR.fpi.rows || 20,
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#and': this.SR.searchValue,
        'in:_id|array#and': this.SR.ids, //按服务区域关联的服务资源筛选
        'in:resourceType|array#and': this.SR.resourceType && this.SR.resourceType.join(),
        notFilterBelongTo: '1'
      };
      let resourceRoles =
        this.SR.nodeType == 'dispatch' &&
        ((this.SR.resourceRoleIds && this.SR.resourceRoleIds.join()) ||
          this.SR.resourceRoles
            .map(item => {
              return item.value;
            })
            .join());
      if (resourceRoles) params['in:resourceRoles|array#and'] = resourceRoles;
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        async res => {
          //收集服务资源id、组织id、用户id
          let SRIds = [];
          let orgIds = [];
          let userIds = [];
          res.data.map(item => {
            // 展示服务资源的待完成工单数和待完成工单类型
            if (item.exts.allCount || item.exts.allCount === 0) this.SR.allCountShow = true;
            if (item.exts.otherCount) this.SR.otherCountShow = true;

            SRIds.push(item._id);
            if (item.resourceType == 'partner' || item.resourceType == 'serviceCrew') {
              //伙伴、班组
              orgIds.push(item.serviceCrewId);
            } else {
              //technician技师、dispatcher派单员
              userIds.push(item.relatedRecordId);
            }
          });

          //获取服务区域、组织、用户 用作返显服务区域和资源名称
          if (SRIds.length > 0) {
            await new Promise(resolve => {
              this.getST(SRIds.join(), resolve);
            });
            if (orgIds.length > 0) {
              await new Promise(resolve => {
                this.getOrgs(orgIds.join(), resolve);
              });
            }
            if (userIds.length > 0) {
              await new Promise(resolve => {
                this.getUsers(userIds.join(), resolve);
              });
            }
          }
          this.SR.fpi = res;
          this.SR.loading = false;
        },
        {
          noload: true
        }
      );
    }, //获取所有服务区域支持搜索
    getServiceTerritory(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'regex:name|string#and': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = (item.relatedIds && item.relatedIds.join()) || ' ';
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //获取当前服务资源列表所属的服务区域 返显
    getST(SRIds, resolve) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'in:relatedIds|array#and': SRIds,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.relatedIds;
          });
          this.options.ST = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    selectSR(row) {
      if (row) {
        this.SR.selectRow = row;
        this.SR.selectId = row._id;
      }
    },
    handleSRRowClick(row) {
      this.$refs.srTable.toggleRowSelection(row);
    },
    handleSRRowSelectionChange(selection){
      if (selection && selection.length > 0) {
        this.SR.selectRow = selection[0];
        this.SR.selectRowNames = selection.map(item => item.name).join();
        this.SR.selectId = selection[0]._id;
        if (selection[0].resourceType == 'partner' || selection[0].resourceType == 'serviceCrew') {
          this.SR.selectIds = selection.map(item => item.serviceCrewId);
        }else {
          this.SR.selectIds = selection.map(item => item.relatedRecordId);
        }
      }else {
        this.SR.selectRow = {};
        this.SR.selectRowNames = '';
        this.SR.selectId = '';
        this.SR.selectIds = [];
      }
    },
    saveSR() {
      if (!this.SR.selectId) {
        this.osg.toast('请选择服务资源！', 'warning');
        return;
      }
      let opt = {};
      if (
        this.SR.selectRow.resourceType == 'partner' ||
        this.SR.selectRow.resourceType == 'serviceCrew'
      ) {
        opt.currentOrgId = this.SR.selectIds[0];
        opt.currentOrgIds = this.SR.selectIds.join();
      } else {
        opt.handlerId = this.SR.selectIds[0];
        opt.handlerIds = this.SR.selectIds.join();
      }
      this.osg.confirm(
        `是否确认${this.currentNode.nodeDef.name}给 ${this.SR.selectRowNames}`,
        () => {
          this.process(this.currentNode, this.SR.btn, this.currentNode.formDataId, opt);
          this.cancelSR();
        }
      );
    },
    cancelSR() {
      this.SR.show = false;
      this.SR.selectRow = {};
      this.SR.selectId = '';
      this.SR.searchValue = '';
      this.SR.resourceType = []; //筛选服务资源类型
      this.SR.resourceRoleIds = []; //筛选资源角色id
      this.SR.resourceRoles = []; //筛选资源角色
      this.SR.btn = {};
      this.SR.allCountShow = false;
      this.SR.otherCountShow = false;
    },
    pageSizeChange(pageSize) {
      if (this.SR.show) {
        this.SR.fpi.rows = pageSize;
        this.getSR();
      }
    },
    pageChange(currentPage) {
      if (this.SR.show) {
        this.SR.fpi.page = currentPage;
        this.getSR();
      }
    },
    formatSRType(row, column, cellValue) {
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatST(row, column, cellValue) {
      return this.osg.codelabelInArray('ST', cellValue);
    },
    formatWorkingState(row, column, cellValue) {
      return this.osg.codelabel('workingStates', cellValue);
    },
    formatOrg(cellValue) {
      return this.osg.codelabel('org', cellValue);
    },
    formatUser(cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    formatResourceRoles(row, column, cellValue) {
      return this.osg.codelabelForArray('resourceRoles', cellValue);
    },
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'note':
          this.getNote();
          break;
        case 'history':
          this.getHistory();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'followingUpNote':
          this.getFollowingUpNote();
          break;
        case 'correlation':
          this.getCorrelation();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: this.colName,
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'asc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;

      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          smodule: this.historySmodule,
          sid: this.id,
          _all: '1'
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          } else {
            this.historyFpi = {
              page: 1,
              rows: 0,
              data: []
            };
          }
        },
        { noload: true }
      );
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: this.colName,
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'asc',
          notFilterBelongTo: '1',
          notFilterOrgId: '1'
        },
        res => {
          res.map(item => {
            item.show = false;
          });
          this.note.data = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      this.osg.ajax(
        'note/upsert.do',
          {
            data: JSON.stringify({
              sid: this.id,
              smodule: this.colName,
              content: this.note.vqeditor.content
            })
          },
        () => {
          this.note.show = false;
          this.getNote();
        }
      );
    },
    getServiceAppointmentById(id) {
      this.osg.ajax(
        `basic/serviceAppointment/queryById/${id || this.id}.do`,
        {},
        res => {
          this.serviceAppointment = res.data.serviceAppointment;
          // TODO:贝壳如视表头展示:设备SN号、设备型号、工单编号
          if (this.serviceAppointment.tenantId == '8072446751847564486') {
            this.formHeader = {
              orderNum: this.serviceAppointment.orderNum,
              deviceNumber: this.serviceAppointment.exts.deviceNumber,
              productModel: this.serviceAppointment.exts.productModel
            };
          }
          // 通过手机号查询关联工单
          if (this.osg.has(`Flow/${this.colName},correlation`)) {
            this.activeTab = 'correlation';
            this.osg.getFields(
              'serviceAppointment',
              () => {
                this.getCorrelation();
              },
              this,
              'SAFields'
            );
          }
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getWorkOrderById(callback) {
      this.osg.ajax(
        'basic/workOrder/findById.do',
        { id: this.id },
        res => {
          this.workOrder = res.data.workOrder;
          if (callback) callback();
        },
        {
          noload: true
        }
      );
    },
    // 关注
    concern() {
      this.osg.ajax(
        `basic/${this.colName}/concern.do`,
        {
          id: this.id
        },
        () => {
          this.colName == 'serviceAppointment'
            ? this.getServiceAppointmentById()
            : this.colName == 'workOrder'
            ? this.getWorkOrderById()
            : null;
        }
      );
    },
    // 超时提醒倒计时
    countdown(node) {
      let timeout;
      let timeout2;
      let timeout3;
      // 超时提醒1
      if (node.nodeDef.alertType && node.nodeDef.alertTypeCount) {
        // 将超时时间段转换为毫秒
        switch (node.nodeDef.alertType) {
          case '1': //分钟
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60;
            break;
          case '2': //小时
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60;
            break;
          case '3': //天
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24;
            break;
          case '4': //周
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 7;
            break;
          case '5': //月
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '6': //自然月
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '7': //季
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 30 * 3;
            break;
          case '8': //年
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 365;
            break;
          case '9': //自然年
            timeout = Number(node.nodeDef.alertTypeCount) * 1000 * 60 * 60 * 24 * 365;
            break;
        }
      }
      // 超时提醒2
      if (node.nodeDef.alertType2 && node.nodeDef.alertType2Count) {
        // 将超时时间段转换为毫秒
        switch (node.nodeDef.alertType2) {
          case '1': //分钟
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60;
            break;
          case '2': //小时
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60;
            break;
          case '3': //天
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24;
            break;
          case '4': //周
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 7;
            break;
          case '5': //月
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '6': //自然月
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '7': //季
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 30 * 3;
            break;
          case '8': //年
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 365;
            break;
          case '9': //自然年
            timeout2 = Number(node.nodeDef.alertType2Count) * 1000 * 60 * 60 * 24 * 365;
            break;
        }
      }
      // 超时提醒3
      if (node.nodeDef.alertType3 && node.nodeDef.alertType3Count) {
        // 将超时时间段转换为毫秒
        switch (node.nodeDef.alertType3) {
          case '1': //分钟
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60;
            break;
          case '2': //小时
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60;
            break;
          case '3': //天
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24;
            break;
          case '4': //周
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 7;
            break;
          case '5': //月
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '6': //自然月
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 30;
            break;
          case '7': //季
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 30 * 3;
            break;
          case '8': //年
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 365;
            break;
          case '9': //自然年
            timeout3 = Number(node.nodeDef.alertType3Count) * 1000 * 60 * 60 * 24 * 365;
            break;
        }
      }

      // 将节点生成时间转换为毫秒
      let createTime = Date.parse(node.createTime.replace(/-/g, '/'));
      console.log('createTime', createTime);

      if (node.state == 0) {
        const countdownFunc = () => {
          // 每分钟获取1次当前时间毫秒值 进行判断
          // 当前时间 - 节点生成时间 - 超时时间段
          let now = new Date().getTime();
          let arr = [];
          if (timeout3) {
            console.log('timeout3', now, createTime, timeout3);
            let ms = now - createTime - timeout3;
            if (ms < 0) {
              arr.push({ overtime: false, msg: '还有' + this.date.count(ms, 'm') + '超时' });
            } else {
              arr.push({ overtime: true, msg: '已超时' + this.date.count(ms, 'm') });
            }
          }
          if (timeout2) {
            console.log('timeout2', now, createTime, timeout2);
            let ms = now - createTime - timeout2;
            if (ms < 0) {
              arr.push({ overtime: false, msg: '还有' + this.date.count(ms, 'm') + '超时' });
            } else {
              arr.push({ overtime: true, msg: '已超时' + this.date.count(ms, 'm') });
            }
          }
          if (timeout) {
            console.log('timeout', now, createTime, timeout);
            let ms = now - createTime - timeout;
            if (ms < 0) {
              arr.push({ overtime: false, msg: '还有' + this.date.count(ms, 'm') + '超时' });
            } else {
              arr.push({ overtime: true, msg: '已超时' + this.date.count(ms, 'm') });
            }
          }
          this.countdownTimers = arr;
        };

        countdownFunc(); //立即执行
        this.countdownTimer = setInterval(countdownFunc, 60000);
      } else if (node.state == 10) {
        // 已完成节点不再倒计时
        // 节点完成时间 - 节点生成时间 - 超时时间段
        this.countdownTimer = setTimeout(
          (() => {
            let now = Date.parse(node.updateTime.replace(/-/g, '/'));
            let arr = [];
            if (timeout3) {
              let ms = now - createTime - timeout3;
              if (ms > 0) {
                arr.push({ overtime: true, msg: '超时' + this.date.count(ms, 'm') + '完成' });
              }
            }
            if (timeout2) {
              let ms = now - createTime - timeout2;
              if (ms > 0) {
                arr.push({ overtime: true, msg: '超时' + this.date.count(ms, 'm') + '完成' });
              }
            }
            if (timeout) {
              let ms = now - createTime - timeout;
              if (ms > 0) {
                arr.push({ overtime: true, msg: '超时' + this.date.count(ms, 'm') + '完成' });
              }
            }
            this.countdownTimers = arr;
          })(),
          60000
        );
        clearTimeout(this.countdownTimer);
      }
    },
    //拨打电话回调，将callid存储，如果要记录跟进记录，存储到跟进记录对象上
    callOutBack(data) {
      if (data) {
        this.callId = data.callId;
        this.activeTab = 'record';
        this.$emit('objectDataFn', {
          exhaleOpen: true, //打开呼出
          bizId: this.id,
          bizType: this.colName,
          callId: data.callId,
          caller: this.formData.phone,
          formData: this.formData,
          extFields: this.extFields || {},
          SAextFields: this.SAextFields || {},
          options: this.options,
          handleType: 'review'
        });
      }
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          if (res.data) {
            this.record.callData = res.data;
            this.record.openCallRecord = true;
          }
        },
        { noload: true }
      );
    },
    getAccidentWarrantyPdfList(_id) {
      if (!_id) return;
      this.osg.ajax(
        'document/queryById.do',
        {
          id: _id
        },
        res => {
          if (res.exts && res.exts.accidentWarrantyPdfList.length) {
            res.exts.accidentWarrantyPdfList.reverse(); //倒序展示，最新在最上面
            this.accidentWarrantyPdfList = res.exts.accidentWarrantyPdfList.map((item, index) => {
              let items = {
                index: index + 1,
                url: item
              };
              return items;
            });
          }
        },
        { noload: true }
      );
    },
    formatCallResult(val) {
      if (!val) return '';
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    /**
     * 查询下单节点关联订单
     */
    getOrders() {
      if (!this.serviceAppointment._id) {
        this.osg.toast('暂无订单');
        return;
      }
      this.osg.ajax(
        'basic/order/query.do',
        {
          _all: 1,
          serviceAppointmentId: this.serviceAppointment._id,
          sortField: 'createTime',
          sortOrder: 'desc',
          'is:type|integer#and': 1,
          'is:state|integer#and': 1
        },
        res => {
          if (res.data.length == 0) {
            this.osg.toast('暂无订单');
            return;
          }
          res.data.map(item => {
            item.productShow = false;
          });
          this.orders = res.data;

          // 返显单位
          this.options['codecfg_productUnit'] = {
            codeId: 'partUnit',
            eleid: 'partUnit'
          };
          this.osg.codeoption();
        }
      );
    },
    formatPayType(val) {
      return this.osg.codelabel('payType', val);
    },
    // 获取关联工单
    getCorrelation() {
      let phoneList = [];
      phoneList.push(this.serviceAppointment.phone);
      if (this.serviceAppointment.exts.phoneList) {
        this.serviceAppointment.exts.phoneList.map(item => {
          phoneList.push(item.phone);
        });
      }
      if (phoneList.length == 0) return;
      let params = {
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:phone|array#and': phoneList.join()
      };
      this.osg.ajax('basic/serviceAppointment/query.do', params, res => {
        this.correlation = res.data;
        this.$forceUpdate();
      });
    },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('productUnit', cellValue);
    },
    // 判断是否展示右侧区域
    isTabsShow() {
      for (let tabName of this.tabNames) {
        if (this.osg.has(`Flow/${this.colName},${tabName}`)) {
          if (this.user.tenantId == '4363416483534256239') {
            this.tabsShow = 0;
          } else {
            this.tabsShow = true;
          }
          return;
        }
      }
      this.tabsShow = false;
    },
    // 取消延时
    delayTimeConfirm() {
      let number = Number(this.delayTime.number);
      if (number || number === 0) {
        if (number <= 0) {
          this.osg.toast('请输入大于0的数字！', 'warning');
          return;
        }
      }
      if (!Number.isInteger(number)) {
        this.osg.toast('请输入整数！', 'warning');
        return;
      }
      this.delayTime.number = Math.floor(number);

      this.osg.ajax(
        'sla/delayed.do',
        {
          workflowNodeId: this.currentNode._id,
          timeCount: this.delayTime.number,
          timeType: this.delayTime.timeType
        },
        () => {
          this.getNodes();
          this.delayTime = {
            show: false,
            number: 30,
            timeType: 1
          };
        }
      );
    },
    // 确认延时
    delayTimeCancel() {
      this.delayTime = {
        show: false,
        number: 30,
        timeType: 1
      };
    },
    async variableParse(str) {
      let nodeIds = str.match(/\$\d+./g);
      let formDatas = {}; // 全部用到的表单数据
      for (let nodeId of nodeIds) {
        nodeId = nodeId.substring(1, nodeId.length - 1); // 去掉$和.
        for (let i = 0; i < this.nodes.length; i++) {
          // 找到指定节点
          if (nodeId == this.nodes[i].nodeId) {
            let node = this.nodes[i];
            if (node.formDataId && node.nodeDef.formDefId && !formDatas[nodeId]) {
              await new Promise(resolve => {
                this.osg.ajax(
                  'biz/extForm/query/' + node.nodeDef.formDefId + '.do',
                  { _id: node.formDataId },
                  res => {
                    formDatas[node.nodeId] = res.data[0];
                    resolve();
                  }
                );
              });
            }
            break;
          }
        }
      }
      console.log('当前公式用到的所有节点表单数据formDatas', formDatas);
      return str.replace(/\$[0-9a-zA-Z._-]*#=[0-9a-zA-Z.,_$#()-]*;/g, str => {
        // 去掉分号
        str = str.substring(0, str.length - 1);
        // key 去掉$#
        let key = str.split('=')[0];
        key = key.substring(1, key.length - 1);
        let keyArr = key.split('.');
        let nodeId = keyArr[0];
        let fieldName = keyArr[keyArr.length - 1];
        if (nodeId == this.currentNode.nodeId) {
          if (keyArr.length == 3) {
            // key = `this.formData.exts.${fieldName}`;
            key = `this.$set(this.formData.exts,'${fieldName}'`;
          } else {
            key = `this.formData.${fieldName}`;
          }
        } else {
          return '';
        }

        let values = str.split('=')[1];
        values = values.replace(/\$[0-9a-zA-Z._-]*#/g, value => {
          // value 去掉$#
          value = value.substring(1, value.length - 1);
          let valueArr = value.split('.');
          let nodeId = valueArr[0];
          let formData = formDatas[nodeId]; // 指定节点表单数据
          let fieldName = valueArr[valueArr.length - 1];
          if (valueArr.length == 3) {
            return `'${(formData && formData.exts && formData.exts[fieldName]) || ''}'`;
          } else {
            return `'${(formData && formData[fieldName]) || ''}'`;
          }
        });

        if (key.indexOf('.$set(') != -1) {
          return `${key},${values});`;
        } else {
          return `${key}=${values};`;
        }
      });
    },
    async formulaParse(node, type) {
      if (type == 'initForm') {
        if (!node.nodeDef.formInitFormula) return;
        console.log('formInitFormula解析前的公式：', node.nodeDef.formInitFormula);
        let formulaParsed = await this.variableParse(node.nodeDef.formInitFormula);
        console.log('解析后的公式：', formulaParsed);
        eval(formulaParsed);
      } else if (type == 'submitForm') {
        if (!node.nodeDef.formSubmitFormula) return;
        console.log('formSubmitFormula解析前的公式：', node.nodeDef.formSubmitFormula);
        let formSubmitFormula = await this.variableParse(node.nodeDef.formSubmitFormula);
        console.log('解析后的公式：', formSubmitFormula);
        eval(formSubmitFormula);
      }
    }
  },
  watch: {
    $route() {
      this.colName = this.osg.param('colName');
      this.id = this.osg.param('id');
      this.user = JSON.parse(sessionStorage['loginAccount']);
      if (sessionStorage['userData']) {
        this.serviceState = JSON.parse(sessionStorage['userData']).serviceState || '';
      }

      this.getExtByColName(() => {
        this.getNodes();
      });
      this.osg.codeoption();
      this.getNote();

      // 工单工作流查询工单数据，支持关注功能
      if (this.colName == 'serviceAppointment') {
        this.getServiceAppointmentById();
      } else if (this.colName == 'workOrder') {
        this.getWorkOrderById(() => {
          // 查询售后工单关联的服务工单
          if (this.workOrder.serviceAppointmentId) {
            this.osg.getFields(
              'serviceAppointment',
              () => {
                this.$forceUpdate();
                this.getServiceAppointmentById(this.workOrder.serviceAppointmentId);
              },
              null,
              'SAFields'
            );
          }

          // 获取跟进记录、通话记录
          if (this.workOrder.phone) {
            this.osg.getFields(
              'followingUpNote',
              () => {
                this.getFollowingUpNote();
                this.getCallRecords();
              },
              this,
              'followingUpNoteFields'
            );
          }

          //有出险质保菜单则查询
          if (this.osg.has(`Flow/${this.colName},accidentWarrantyPdfList`)) {
            this.getAccidentWarrantyPdfList(this.workOrder.exts.docId);
          }
        });
      }

      // 获取跟进记录、通话记录
      if (this.osg.has(`Flow/${this.colName},returnVisit`)) {
        this.osg.getFields(
          'followingUpNote',
          () => {
            this.getFollowingUpNote();
          },
          this,
          'followingUpNoteFields'
        );
      }
    }
  }
};
</script>
<style lang="scss">
#app .flow {
  background-color: #f2f2f2;
  .flow-top {
    overflow-x: auto;
    .c-steps {
      display: flex;
      padding: 10px 5px;
      align-items: center;
      .c-step {
        display: flex;
        align-items: center;
        position: relative;
        .c-step-node {
          background-color: #fff;
          padding: 8px;
          border-radius: 8px;
          border: 1px solid transparent;
          cursor: pointer;
          font-size: 14px;
          box-shadow: 0 1px 4px 0 rgb(10 30 65 / 16%);
          width: 120px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          box-sizing: border-box;
          &:hover {
            border-color: #0089ff;
          }
        }
        .c-step-icon-left {
          font-weight: 700;
        }
        .c-step-icon-right {
          margin: auto 8px;
          color: rgba(0, 0, 0, 0.3);
        }
        .c-step-done {
          color: #67c23a;
        }
        .c-step-doing {
          color: #409eff;
        }
        .c-steps-sub {
          position: absolute;
          .c-steps-bottom {
            position: absolute;
            top: -20px;
            left: 52px;
            color: rgba(0, 0, 0, 0.3);
          }
        }
      }
      .c-step-active {
        > .c-step-node {
          border-color: #0089ff;
          background-color: #f7f9ff;
        }
      }
    }
  }
  .flow-content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    position: relative;
    .c-node-form {
      width: 100%;
      min-width: 500px;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      .c-node-form-header {
        padding: 10px;
        font-size: 14px;
        border-bottom: 1px solid #f2f2f2;
        > div {
          display: flex;
          justify-content: space-between;
        }
        .c-node-form-timers {
          flex-wrap: wrap;
          justify-content: flex-start;
          .el-button {
            margin: 5px 5px 0 0;
          }
        }
      }
      .c-node-form-content {
        padding: 20px;
        flex: 1;
        overflow-y: auto;
      }
      .c-node-form-footer {
        padding: 10px;
        border-top: 1px solid #f2f2f2;
        text-align: center;
        display: flex;
        justify-content: space-around;
        .el-button {
          margin-left: 0;
        }
      }
    }
    .flow-content-right {
      margin-left: 20px;
      width: 450px;
      min-width: 350px;
      background-color: #fff;
      padding: 10px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      box-sizing: border-box;
      .el-tabs__header {
        margin: 0;
        height: 50px;
        .el-tabs__item {
          height: 50px;
          line-height: 50px;
          min-width: 120px;
          text-align: center;
        }
      }
      .el-tabs__content {
        overflow-y: auto;
        padding: 10px 5px 5px;
        .el-tab-pane {
          height: 100%;
          .c-note {
            height: 100%;
            display: flex;
            flex-direction: column;
            .box-center-content {
              overflow-y: auto;
              flex-grow: 1; // 兼容ie
            }
          }
        }
        .box-center-tool {
          padding: 0 !important;
        }
      }
    }
    .concern {
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .el-dialog {
      margin: 10vh auto 10vh !important;
      height: 80vh;
    }
    .tabShowBtn {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  .sr-dialog {
    width: 1000px !important;
  }
}
</style>
